import { FilterButton } from '../../components/admin/filter-form';
import { MoonstarListActions } from '../Moonstar/MoonstarListActions';
import { AddUsersButton } from './AddUsersButton';
import { BulkDisableUsersButton } from './BulkDisableUsersButton';
import { BulkUpdateUsersButton } from './BulkUpdateUsersButton';
import { ListExportButton } from '../../components/custom/ListExportButton';
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen';

export const UserToolbarActions = () => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <MoonstarListActions
      left={<FilterButton />}
      createLabel="Add single user"
      right={
        <>
          {!isSmallScreen && (
            <>
              <AddUsersButton />
              <BulkUpdateUsersButton />
              <BulkDisableUsersButton />
            </>
          )}
          <ListExportButton maxResults={Infinity} />
        </>
      }
    />
  );
};
